<template>
  <SideNav />

  <header class="bg-gradient-dark">
    <div
      class="page-header min-vh-60"
      style="background-image: url('assets/img/videopic.jpg');"
      loading="lazy"
    >
      <span class="mask bg-gradient-dark opacity-3" />
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center mx-auto my-auto">
            <h2 class="text-white">
              Work with an <br class="d-md-none">amazing <span
                class="text-white"
                id="typed"
              />
            </h2>
            <div id="typed-strings">
              <h1>team</h1>
              <h1>design</h1>
              <h1>tool</h1>
            </div>
            <p class="lead mb-4 text-white opacity-8">
              昀揚科技，<br class="d-md-none">用科技引領生活的改變
            </p>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- -------- END HEADER 7 w/ text and video ------- -->


  <div class="card card-body shadow-xl mx-2 mx-md-4 mt-n6">
    <div class="col-lg-6 mx-auto text-center fadeIn1 fadeInBottom">
      <h3 class="my-4 my-md-5">
        核心開發優勢與理念
      </h3>
    </div>
    <div
      class="container py-md-5 px-md-3 px-0 mb-4"
      id="RAO"
    >
      <div
        class="row align-items-center fadeIn2 fadeInBottom"
      >
        <div
          class="col-md-6 mb-md-0 mb-4 order-1 order-md-2"
        >
          <h5 class="text-dark mb-2 mt-4 mt-md-0">
            開發優勢
          </h5>
          <p>
            CloudRasie Resources Access Optimization ( RAO )  技術
          </p>
          <p>
		&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;
    		昀揚科技多年與上市櫃公司及政府機構合作經驗研發出 RAO 技術， 改善大型網路應用平台在環境嚴苛且複雜的資料邏輯及百萬級別高壓存取環境的異步、延遲、封包遺失等問題，透過各種演算法大幅降低資料在傳輸層與應用層相依及遞移的資料錯誤問題，利用壓縮、快取、優化、封包壓縮將每一個存取反應控制在極低的時間內。
		<br/>
		&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;
		即便在面臨數百萬筆 Session 的演算時，RAO技術具備高一致性有效降低開發週期與成本並大幅度提高生產品質，讓生產人員有著標準化及可自動化檢查的整合介面，提供客戶更加安全、可靠、穩定、高效、高可併發的雲端運算及應用服務。
          </p>
        </div>
        <div class="col-md-6 order-2 order-md-1">
          <div class="card p-0 border-radius-lg">
            <div class="blur-shadow-image">
              <img
                src="assets/img/dev1.jpg"
                alt="img-blur-shadow"
                class="img-fluid border-radius-lg"
                loading="lazy"
              >
            </div>
            <div
              class="colored-shadow"
              style="background-image: url(&quot;assets/img/dev1.jpg&quot;);"
            />
          </div>
        </div>
      </div>
    </div>       



    <div class="container py-md-5 px-md-3 px-0">
      <div class="row align-items-center fadeIn2 fadeInBottom">
        <div class="col-md-6 mb-md-0 mb-4 order-2 order-md-1">
          <h5 class="text-dark mb-4 mt-4 mt-md-0">
            開發理念
          </h5>
          <div class="p-3 d-flex px-0 py-1 mb-2">
            <i class="material-icons text-primary font-weight-bold pt-1">done</i>
            <div class="ps-3">
              <span class=" font-weight-bold">
			用科技引領生活的改變
		</span>
            </div>
          </div>            
          <div class="p-3 d-flex px-0 py-1 mb-2">
            <i class="material-icons text-primary font-weight-bold pt-1">done</i>
            <div class="ps-3">
              <span class=" font-weight-bold">
			積極與各領域單位合作研發品質更高、成本更低的產品
		</span>
            </div>
          </div>            
          <div class="p-3 d-flex px-0 py-1 mb-2">
            <i class="material-icons text-primary font-weight-bold pt-1">done</i>
            <div class="ps-3">
              <span class=" font-weight-bold">
			明定開發作業、生產管理及品質稽核的嚴格規範
		</span>
            </div>
          </div>            
          <div class="p-3 d-flex px-0 py-1 mb-2">
            <i class="material-icons text-primary font-weight-bold pt-1">done</i>
            <div class="ps-3">
              <span class=" font-weight-bold">
			一處開發、全載具可同時佈建;一團隊開發、全載具可同團隊維運
		</span>
            </div>
          </div>            
          <div class="p-3 d-flex px-0 py-1 mb-2">
            <i class="material-icons text-primary font-weight-bold pt-1">done</i>
            <div class="ps-3">
              <span class=" font-weight-bold">
			恪守三高一低（高品質、高效率、高擴展性、低成本）的研發精神
		</span>
            </div>
          </div>            
          <div class="p-3 d-flex px-0 py-1 mb-2">
            <i class="material-icons text-primary font-weight-bold pt-1">done</i>
            <div class="ps-3">
              <span class=" font-weight-bold">
			研發可高速、批量生產軟體的開發引擎，並建立政策標準化之作業生產流水線
		</span>
            </div>
          </div>            
        </div>
        <div class="col-md-6 order-1 order-md-2">
          <div class="card p-0 border-radius-lg">
            <div class="blur-shadow-image">
              <img
                src="assets/img/examples/card-project5.jpg"
                alt="img-blur-shadow"
                class="img-fluid border-radius-lg"
                loading="lazy"
              >
            </div>
            <div
              class="colored-shadow"
              style="background-image: url(&quot;assets/img/examples/card-project5.jpg&quot;);"
            />
          </div>
        </div>
      </div>
    </div>      
    <div class="container py-5 fadeIn3 fadeInBottom text-center px-md-3 px-0">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <div class="shadow border-radius-lg">
            <a class="d-block">
              <img
                src="assets/img/workpro.jpg"
                class="img-fluid border-radius-lg"
              >
            </a>
          </div>
        </div>    
        <div class="col-lg-4 text-center mt-4">
          <h5 class="mb-2">
            系統架構 : 全面採用容器化微服務架構
          </h5>           
        </div>
      </div>    
    </div>    
    <div class="container py-5 px-md-3 px-0">
      <div class="row align-items-center">          
        <div class="col-lg-4 text-center mt-4 order-2 order-lg-1">
          <h5 class="mb-2">
            標準化的開發作業流程
          </h5>           
        </div>
        <div class="col-lg-8 order-1 order-lg-2">
          <div class="shadow border-radius-lg">
            <a class="d-block">
              <img
                src="assets/img/workpro2.jpg"
                class="img-fluid border-radius-lg"
              >
            </a>
          </div>
        </div>
      </div>
    </div>          
    <section
      class="py-md-7"
      id="K8S"
    >
      <div class="container px-md-3 px-0">
        <div class="row justify-content-start">
          <div class="col-md-6">
            <div class="primary text-start border-radius-lg">
              <div class="icon icon-md icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4">
                <i
                  class="material-icons opacity-10"
                  style="  top:11px;"
                >token</i>
              </div>
              <h5 class="mt-3">
                後端開發
              </h5>
              <div class="p-3 d-flex px-0 py-1 mb-2">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class=" font-weight-bold">
                    產品全面採用 RESTFull API 風格架構，支援 Postman API 手冊及測試腳本，
                    提供多種跨載具整合 SDK & Component。
                  </span>
                </div>
              </div>              
              <div class="p-3 d-flex px-0 py-1 mb-2">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class=" font-weight-bold">遵守 OPENAPI 3.0 架構，API 介面標準化的一致性提供了系統高度的擴展性和可重覆利用性大幅度節省人員開發與整合成本。</span>
                </div>
              </div>    
              <div class="p-3 d-flex px-0 py-1 mb-2">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class=" font-weight-bold">透過標準化後端介面，組裝後端開發引擎工具及模組，使用「容器集裝箱」概念使功能模組達到可高重覆利用性及擴展性</span>
                </div>
              </div>    
            </div>     
          </div> 
            
          <div class="col-md-6 mt-5 mt-md-0">
            <div class="primary text-start border-radius-lg">
              <div class="icon icon-md icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4">
                <i
                  class="material-icons opacity-10"
                  style="  top:11px;"
                >terminal</i>
              </div>
              <h5 class="mt-3">
                前端開發
              </h5>
              <div class="p-3 d-flex px-0 py-1 mb-2">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class=" font-weight-bold">Hybrid 架構：一處開發全載具可佈署</span>
                </div>
              </div>            
              <div class="p-3 d-flex px-0 py-1 mb-2">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class=" font-weight-bold">採構多套成熟穩定國外知名元件公司的元件授權，且採構元件授權範圍均為全球 End Product 可再授權版本</span>
                </div>
              </div>            
              <div class="p-3 d-flex px-0 py-1 mb-2">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class=" font-weight-bold">透過標準化前端介面，組裝前端開發引擎工具及模組，達到可高重覆利用性及擴展性</span>
                </div>
              </div>
            </div>
          </div>
            
          <div class="col-md-6 mt-5">
            <div class="text-start">
              <div class="icon icon-md icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4">
                <i
                  class="material-icons opacity-10"
                  style="  top:11px;"
                >create_new_folder</i>
              </div>
              <h5 class="mt-3">
                系統建置
              </h5>
              <div class="p-3 d-flex px-0 py-1 mb-2 mb-3">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class="font-weight-bold">高敏捷建置效率</span>
                </div>
              </div>              
              <ul class="ms-3">
                <li class="mb-3 ps-1">
                  採用 Kubernetes ( K8s )及 Docker composer 自動佈署與管理容器
                </li>
                <li class="mb-3 ps-1">
                  產品的每一個平台系統（Node）皆可部署（Depolyment）於一個實體伺服器或虛擬伺服器，您可以彈性選擇要將本產品佈署於您的私有雲或公有雲（Azure、AWA、GCP 等 SaaS Platform）。
                </li>
                <li class="ps-1">
                  可快速完成 DEV(開發)、UT (單元測試)、IT (整合測試)、ST (系統測試)、UAT (驗收測試)，正式環境佈署
                </li>
              </ul>
            </div> 
          </div>
          <div class="col-md-6 mt-5">    
            <div class="primary text-start border-radius-lg">
              <div class="icon icon-md icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 ">
                <i
                  class="material-icons opacity-10 "
                  style="  top:11px;"
                >view_timeline</i>
              </div>
              <h5 class="mt-3">
                容器化微服務架構（Containerizations , Microservices Achitecture）
              </h5>
              <div class="p-3 d-flex px-0 py-1 mb-2 mb-3">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class="font-weight-bold">全面採用容器化微服務架構，使系統具備高度的整合擴展性，在各種復雜的 IT 使用情境和整合需求下有著最活潑的解決方案。</span>
                </div>
              </div>  
              <div class="p-3 d-flex px-0 py-1 mb-2 mb-3">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class="font-weight-bold">面對 Infra 端的管理採用 Kubernetes ( K8S ) 來管理微服務 ( Microservices ) ，您可以輕鬆並且高效的部署 ( Depolyment )容器（Container）與 各種服務（Services）。</span>
                </div>
              </div>  


              <div class="p-3 d-flex px-0 py-1 mb-2 mb-3">
                <i class="material-icons text-primary font-weight-bold pt-1">done</i>
                <div class="ps-3">
                  <span class="font-weight-bold">
                    系統架構高度的可靠性（Reliability）、可用性（Availability）、可維護性（Serviceability）大幅度的節省部署與維運成本
                  </span>
                </div>
              </div>     
              <ul class="ms-3">
                <li class="mb-3 ps-1">
                  節省5倍以上 INFRA 維運人力
                </li>
                <li class="mb-3 ps-1">
                  高併發、高流量：可支援百萬級至千萬級的高併發、高存取使用量
                </li>
                <li class="ps-1">
                  快速擴充：比傳統架構快上數百倍的擴充效率
                </li>
              </ul>    
            </div>
          </div>
        </div>
      </div>
    </section>  


    <section class="bg-gradient-dark position-relative overflow-hidden mt-5 mx-n3">
      <img
        src="assets/img/shapes/waves-white.svg"
        alt="pattern-lines"
        class="position-absolute opacity-1 w-100 h-100"
        style="object-fit: cover;"
      >
      <div class="container py-lg-6 py-2">
        <div class="row">
          <div class="col-lg-6 d-flex justify-content-center flex-column">
            <div
              id="carouselExampleIndicator"
              class="carousel slide pt-5 pb-7 py-lg-7"
              data-bs-ride="carousel"
            >
              <div class="carousel-indicators justify-content-start ms-0">
                <!--
              <a href="javascript:;">
                <img src="assets/img/01.png" class="avatar avatar-sm avatar-scale-up border-radius-lg shadow border-0 active" data-bs-target="#carouselExampleIndicator" data-bs-slide-to="0">
                <span class="text-white mx-2">&#124;</span>
              </a>
-->
                <!--
              <a href="javascript:;">
                <img src="assets/img/09.png" class="avatar avatar-sm avatar-scale-up border-radius-lg shadow border-0" data-bs-target="#carouselExampleIndicator" data-bs-slide-to="1">
                <span class="text-white mx-2">&#124;</span>
              </a>
              <a href="javascript:;">
                <img src="assets/img/10.png" class="avatar avatar-sm avatar-scale-up border-radius-lg shadow border-0" data-bs-target="#carouselExampleIndicator" data-bs-slide-to="2">
              </a>
-->
              </div>
              <div class="carousel-inner">
                <h2 class="text-white">
                  產品專利
                </h2>
                <p class="text-white opacity-8 mb-1">
                  專屬於昀揚科技的新型發明，提供最完整的產品服務
                </p>
                <hr class="text-white horizontal opacity-6 mb-4 mt-2 w-25 text-start">
                <div class="carousel-item active">
                  <h6 class="text-white pe-5">
                    coming soon
                  </h6>
                  <h6 class="text-white pe-5">
                    多項專利申請，敬請期待
                  </h6>
                  <div class="author mt-4">
                    <div class="name">
                      <span class="text-white">台灣新型</span>
                      <div class="stats">
                        <small class="text-white opacity-6">2023</small>
                      </div>
                    </div>
                  </div>
                </div>
                <!--
              <div class="carousel-item">
                <h6 class="text-white pe-5">學力診斷系統</h6>
                <h6 class="text-white pe-5">根據教育部十二年國民基本教育課程綱要指出，學習重點包含「學習表現」與「學習內容」兩部分，提供課程設計、教材發展、教科書審查及學習評量的架構，並配合教學加以實踐。</h6>
                <div class="author mt-4">
                  <div class="name">
                    <span class="text-white">台灣新型</span>
                    <div class="stats">
                      <small class="text-white opacity-6">2023</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <h6 class="text-white pe-5">學力診斷系統</h6>
                <h6 class="text-white pe-5">根據教育部十二年國民基本教育課程綱要指出，學習重點包含「學習表現」與「學習內容」兩部分，提供課程設計、教材發展、教科書審查及學習評量的架構，並配合教學加以實踐。</h6>
                <div class="author mt-4">
                  <div class="name">
                    <span class="text-white">台灣新型</span>
                    <div class="stats">
                      <small class="text-white opacity-6">2023</small>
                    </div>
                  </div>
                </div>
              </div>
-->
              </div>
            </div>
          </div>
          <div class="col-md-6 justify-content-center flex-column d-sm-none d-md-none d-lg-flex d-xl-flex ">
            <img
              src="assets/img/test1-1.png"
              class="img-fluid my-4 mt-md-0"
            >
          </div>
        </div>
      </div>
    </section>
    
    <!-- -------- END Features w/ pattern background & stats & rocket -------- -->
    <section
      class="pb-6"
      id="count-stats"
    >
<!--
      <div class="row align-items-center my-6">
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
          <img
            src="assets/img/edu.png"
            class="iconlogo"
          >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
          <img
            src="assets/img/lt.png"
            class="iconlogo"
          >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
          <img
            src="assets/img/metmge.png"
            class="iconlogo"
          >
        </div>          
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
          <img
            src="assets/img/authen.png"
            class="iconlogo"
          >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
          <img
            src="assets/img/tact.png"
            class="iconlogo"
          >
        </div>  

        <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
          <img
            src="assets/img/sb.png"
            class="iconlogo"
          >
        </div>  
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 mb-5">
          <img
            src="assets/img/ocean.png"
            class="iconlogo"
          >
        </div>
      </div>   
-->
      <div class="container">
        <div class="row justify-content-center text-center mt-5">
          <div class="col-md-3">
            <h1
              class="text-gradient text-warning"
              id="state1"
              countTo="681"
            >
              0
            </h1>
            <h5>Schools</h5>
            <p>使用我們產品的學校或教育機構</p>
          </div>
          <div class="col-md-3">
            <h1 class="text-gradient text-warning">
              <span
                id="state2"
                countTo="293"
              >0</span>K+
            </h1>
            <h5>Users</h5>
            <p>使用我們產品的使用者</p>
          </div>
          <div class="col-md-3">
            <h1 class="text-gradient text-warning">
              <span
                id="state3"
                countTo="31"
              >0</span>/<span
                id="state4"
                countTo="30"
              >0</span>
            </h1>
            <h5>Patents</h5>
            <p>我們擁有的專利/商標</p>
          </div>
        </div>
      </div>
    </section>
    <!-- -------- END PRE-FOOTER 1 w/ SUBSCRIBE BUTTON AND IMAGE ------- -->
  </div>

  <Footer />
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
//import Header from '@/components/Header.vue';
import { SideNav , Header , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //NavBar,
    // Settings,
    Footer,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(page){
      if(router.currentRoute.value.name == page) { return; }
      router.push(page);
    }

    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
